"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JOB_OFFER_TYPE_TO_NEED_CONTRACT_TYPE = exports.NEED_CONTRACT_TYPE_TO_JOB_OFFER_TYPE = exports.getJobOfferBaseTypesForCountry = exports.JOB_OFFER_TYPES_BY_COUNTRY = exports.withTemporaryVariants = exports.toJobOfferBaseType = exports.isTemporaryJobOfferVariant = exports.isJobOfferType = exports.TEMPORARY_JOB_OFFER_VARIANTS = exports.JOB_OFFER_BASE_TYPES = exports.JOB_OFFER_TYPES = exports.isJobOfferRequiredExperience = exports.JOB_OFFER_EXPERIENCE_TO_NEED_EXPERIENCE = exports.NEED_EXPERIENCE_TO_JOB_OFFER_EXPERIENCE = exports.JOB_OFFER_REQUIRED_EXPERIENCES = void 0;
const lib_custom_types_1 = require("@backend/lib-custom-types");
exports.JOB_OFFER_REQUIRED_EXPERIENCES = (0, lib_custom_types_1.strictUnionArray)()([
    'NONE',
    'ANY',
    'ONE_MONTH',
    'THREE_MONTHS',
    'SIX_MONTHS',
    'ONE_YEAR',
    'TWO_YEARS',
    'FIVE_YEARS',
]);
exports.NEED_EXPERIENCE_TO_JOB_OFFER_EXPERIENCE = {
    ANY_REQUIRED: 'ANY',
    NO_EXP_REQUIRED: 'NONE',
    ONE_MONTH_REQUIRED: 'ONE_MONTH',
    THREE_MONTHS_REQUIRED: 'THREE_MONTHS',
    SIX_MONTHS_REQUIRED: 'SIX_MONTHS',
    ONE_YEAR_REQUIRED: 'ONE_YEAR',
    TWO_FIVE_YEARS_REQUIRED: 'TWO_YEARS',
    FIVE_PLUS_YEARS_REQUIRED: 'FIVE_YEARS',
};
exports.JOB_OFFER_EXPERIENCE_TO_NEED_EXPERIENCE = {
    ANY: 'ANY_REQUIRED',
    NONE: 'NO_EXP_REQUIRED',
    ONE_MONTH: 'ONE_MONTH_REQUIRED',
    THREE_MONTHS: 'THREE_MONTHS_REQUIRED',
    SIX_MONTHS: 'SIX_MONTHS_REQUIRED',
    ONE_YEAR: 'ONE_YEAR_REQUIRED',
    TWO_YEARS: 'TWO_FIVE_YEARS_REQUIRED',
    FIVE_YEARS: 'FIVE_PLUS_YEARS_REQUIRED',
};
const isJobOfferRequiredExperience = (value) => (0, lib_custom_types_1.includes)(exports.JOB_OFFER_REQUIRED_EXPERIENCES, value);
exports.isJobOfferRequiredExperience = isJobOfferRequiredExperience;
exports.JOB_OFFER_TYPES = (0, lib_custom_types_1.strictUnionArray)()([
    'PERMANENT',
    'CONTRACT',
    'SEASONAL_TEMPORARY',
    'NON_SEASONAL_TEMPORARY',
    'TEMPORARY',
]);
exports.JOB_OFFER_BASE_TYPES = (0, lib_custom_types_1.strictUnionArray)()(['PERMANENT', 'CONTRACT', 'TEMPORARY']);
exports.TEMPORARY_JOB_OFFER_VARIANTS = (0, lib_custom_types_1.strictUnionArray)()([
    'SEASONAL_TEMPORARY',
    'NON_SEASONAL_TEMPORARY',
]);
const isJobOfferType = (value) => (0, lib_custom_types_1.includes)(exports.JOB_OFFER_TYPES, value);
exports.isJobOfferType = isJobOfferType;
const isTemporaryJobOfferVariant = (value) => (0, lib_custom_types_1.includes)(exports.TEMPORARY_JOB_OFFER_VARIANTS, value);
exports.isTemporaryJobOfferVariant = isTemporaryJobOfferVariant;
const toJobOfferBaseType = (type) => (0, exports.isTemporaryJobOfferVariant)(type) ? 'TEMPORARY' : type;
exports.toJobOfferBaseType = toJobOfferBaseType;
const withTemporaryVariants = (types) => [
    ...new Set([
        ...types,
        ...((0, lib_custom_types_1.includes)(types, 'TEMPORARY') ? exports.TEMPORARY_JOB_OFFER_VARIANTS : []),
    ]),
];
exports.withTemporaryVariants = withTemporaryVariants;
exports.JOB_OFFER_TYPES_BY_COUNTRY = {
    FR: exports.JOB_OFFER_TYPES,
    IT: ['PERMANENT', 'CONTRACT', 'TEMPORARY'],
    US: ['PERMANENT', 'TEMPORARY'],
};
const getJobOfferBaseTypesForCountry = (country) => [
    ...new Set(exports.JOB_OFFER_TYPES_BY_COUNTRY[country].map(exports.toJobOfferBaseType)),
];
exports.getJobOfferBaseTypesForCountry = getJobOfferBaseTypesForCountry;
exports.NEED_CONTRACT_TYPE_TO_JOB_OFFER_TYPE = {
    FIXED_TERM: 'CONTRACT',
    PERMANENT: 'PERMANENT',
    NON_SEASONAL_TEMPORARY: 'NON_SEASONAL_TEMPORARY',
    SEASONAL_TEMPORARY: 'SEASONAL_TEMPORARY',
    TEMPORARY: 'TEMPORARY',
};
exports.JOB_OFFER_TYPE_TO_NEED_CONTRACT_TYPE = {
    PERMANENT: 'PERMANENT',
    CONTRACT: 'FIXED_TERM',
    SEASONAL_TEMPORARY: 'SEASONAL_TEMPORARY',
    NON_SEASONAL_TEMPORARY: 'NON_SEASONAL_TEMPORARY',
    TEMPORARY: 'TEMPORARY',
};
